import * as R from 'ramda';
import {msToSecond, secondTimeStampDurationText, secondTimeStampText} from '@/utils';

export const table = [
  {label: '订单号', prop: 'publicOrderId'},
  {label: '提交时间', prop: 'submitTime', filter: ({submitTime}) => secondTimeStampText(submitTime)},
  {label: '完成时间', prop: 'processFinishTime', filter: ({processFinishTime}) => secondTimeStampText(processFinishTime)},
  {
    label: '目前用时',
    prop: '_nowTime',
    filter: ({processFinishTime, processStartTime}) => {
      if (processFinishTime && processStartTime) {
        return secondTimeStampDurationText({startTime: processStartTime, endTime: processFinishTime});
      } else if (!processFinishTime && processStartTime) {
        return secondTimeStampDurationText({startTime: processStartTime, endTime: msToSecond(Date.now())});
      }
    },
  },
  // {
  //   label: '患者支付状态',
  //   prop: 'payStatus',
  //   filter: ({payStatus}) => {
  //     if (payStatus === 0) {
  //       return '未支付';
  //     }
  //     if (payStatus === 1) {
  //       return '已支付';
  //     }
  //     if (payStatus === 2) {
  //       return '已退款';
  //     }
  //     return '';
  //   },
  // },
  // {label: '患者支付金额', prop: 'priceSum'},
  // {label: '患者支付时间', prop: 'payTime', filter: ({payTime}) => secondTimeStampText(payTime)},
  // {
  //   label: '经销商支付状态',
  //   prop: 'agentPayStatus',
  //   filter: ({agentPayStatus}) => {
  //     if (agentPayStatus === 0) {
  //       return '未支付';
  //     }
  //     if (agentPayStatus === 1) {
  //       return '已支付(现金)';
  //     }
  //     if (agentPayStatus === 2) {
  //       return '已退款';
  //     }
  //     if (agentPayStatus === 3) {
  //       return '已支付(代金)';
  //     }
  //     if (agentPayStatus === 4) {
  //       return '申请退款';
  //     }
  //     return '';
  //   },
  // },
  // {label: '经销商支付金额', prop: 'agentPriceSum'},
  // {label: '经销商支付时间', prop: 'agentPayTime', filter: ({agentPayTime}) => secondTimeStampText(agentPayTime)},
  {
    label: '服务方案',
    prop: 'itemNames',
    filter: ({itemNames}) => {
      if (R.is(Array, itemNames)) {
        return R.join(',', itemNames);
      }
      return '';
    }
  },
  {label: '提取码', prop: 'code'},
  {label: '医院', prop: 'hospitalName'},
  {label: '科室', prop: 'departmentName'},
  {label: '代理商名称', prop: 'agentName', disabled: true},
  {label: '代理商电话', prop: 'agentMobile', disabled: true},
  {label: '创建医生', prop: 'doctorName', required: true},
  {label: '医生电话', prop: 'doctorPhone'},
  {label: '邮箱', prop: 'email'},
  {label: '患者姓名', prop: 'patientName', required: true},
  {label: '患者ID', prop: 'examPatientId', required: true},
  {label: '患者电话', prop: 'patientPhone'},
  {label: '患者备注', prop: 'patientNote'},
  {label: '病情简述及重建重点', prop: 'note', type: 'textarea', required: true},
  // {label: '是否开发票', prop: 'invoice', filter: ({invoice}) => invoice === 1 ? '是' : '否'},
  // {
  //   label: '发票种类',
  //   prop: 'invoiceTag',
  //   visible: ({invoice}) => {
  //     if (invoice === 1) {
  //       return true;
  //     }
  //     return false;
  //   },
  //   filter: ({invoiceTag}) => invoiceTag === 1 ? '电子发票' : (invoiceTag === 2 ? '纸质发票' : '')
  // },
  // {
  //   label: '发票类型',
  //   prop: 'invoiceType',
  //   visible: ({invoice}) => {
  //     if (invoice === 1) {
  //       return true;
  //     }
  //     return false;
  //   },
  //   filter: ({invoiceType}) => invoiceType === 1 ? '个人/事业单位' : (invoiceType === 2 ? '公司企业' : '')
  // },
  // {
  //   label: '发票抬头',
  //   prop: 'invoiceTitle',
  //   visible: ({invoice}) => {
  //     if (invoice === 1) {
  //       return true;
  //     }
  //     return false;
  //   },
  // },
  // {
  //   label: '发票税号',
  //   prop: 'invoiceTaxNum',
  //   visible: ({invoice}) => {
  //     if (invoice === 1) {
  //       return true;
  //     }
  //     return false;
  //   },
  // },
  // {
  //   label: '收票人手机号',
  //   prop: 'invoicePhone',
  //   visible: ({invoice}) => {
  //     if (invoice === 1) {
  //       return true;
  //     }
  //     return false;
  //   },
  // },
  // {
  //   label: '收票人电子邮箱',
  //   prop: 'invoiceMail',
  //   visible: ({invoice}) => {
  //     if (invoice === 1) {
  //       return true;
  //     }
  //     return false;
  //   },
  // },
  // {
  //   label: '发票地址',
  //   prop: 'invoiceAddr',
  //   visible: ({invoice}) => {
  //     if (invoice === 1) {
  //       return true;
  //     }
  //     return false;
  //   },
  // },
  {
    label: '重建组',
    prop: 'processGroup',
    visible: ({isAdmin, isCaptain}) => {
      if (isAdmin || isCaptain) {
        return true;
      }
      return false;
    }
  },
  {
    label: '重建负责人',
    prop: 'processor',
    visible: ({isAdmin, isCaptain}) => {
      if (isAdmin || isCaptain) {
        return true;
      }
      return false;
    }
  },

];



// WEBPACK FOOTER //
// ./src/view/OrderView/config.js